const config = {
    currentLang: 'i18nextLng',
    accessToken: '@pagina-coach:token',
    refreshToken: '@pagina-coach:refresh_token',
    openaiApiKey: process.env.REACT_APP_OPENAI_API_KEY,
};

export default config;
